import { render, staticRenderFns } from "./quesTemplate.vue?vue&type=template&id=68812949&scoped=true"
import script from "./quesTemplate.vue?vue&type=script&lang=js"
export * from "./quesTemplate.vue?vue&type=script&lang=js"
import style0 from "./quesTemplate.vue?vue&type=style&index=0&id=68812949&prod&scoped=true&lang=less"
import style1 from "./quesTemplate.vue?vue&type=style&index=1&id=68812949&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68812949",
  null
  
)

export default component.exports